export default __webpack_public_path__ + "static/media/image-tenkaan-2.b9c4df52.png";